import { ICommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { APCourseGroup } from '../../../global/builders/ap_course_group_builder';
import { APGenericSlot, NCRSlot } from '../../../global/builders/ap_generic_slot_builder';
import { APPlannedCourse, IAPPlannedCourseMeta } from '../../../global/builders/ap_planned_course_builder';
import { APTerm } from '../../../global/builders/ap_term_builder';
import { StudentValueModel } from '../../../global/components/student_value/model/student_value_model';
import { APComponentStateModel } from '../../../global/models/ap_component_state_model';
import { APCourseServant } from '../../../global/servants/ap_course_servant';
import { APGenericSlotServant } from '../../../global/servants/ap_generic_slot_servant';
import { APTermServant } from '../../../global/servants/ap_term_servant';
import { ITermCourseStatusGroup } from '../../../global/strategies/ap_term_course_status_group_strategy';
import { RoleTypeStrategy } from '../../../global/strategies/user_mode_api_strategy';
import { DEEMPHASIZE_DROP_AREA, EMPHASIZE_DROP_AREA } from '../../../plan/constants/event_names';
import { LargeCourseGroupSearchResultsQuery } from '../large_course_group/queries/large_course_group_search_results_query';
interface ICourseStatusGroup extends ITermCourseStatusGroup {
  filteredCourses: ICourse[];
}

// FIXME: Sync with APCourse, This is a mix of Course, Planned Course and Program_slot
export interface ICourse {
  term: number;
  id: number;
  nk: string;
  course?: number;
  title: string;
  course_group?: string;
  is_favorite: boolean;
  status: string;
  credits: number;
  prereq_outoforder: boolean;
  prereq_miss: boolean;
  coreq_outoforder: boolean;
  coreq_miss: boolean;
  is_devreq: boolean;
  _has_coreq: boolean;
  _has_prereq: boolean;
  _program_slot: number;
  _devreq: ICourse;
  _is_group_course: string;
  _is_course_group: boolean;
  _course_group: string;
  _courses: ICourse[];
  courses?: ICourse[];
}
interface IAcademicPlan {
  terms: APTerm[];
}

angular.module('capability-ng-academic-planner');

export class TermBox {
  private flags: {
    isSaving: boolean;
    showBox: boolean;
  };
  private isPast: boolean;
  private draggingGenericSlot?: APGenericSlot = undefined;
  private isDropAreaActive: boolean = false;
  private courseStatusGroups: Record<string, ICourseStatusGroup> = {};
  private term: APTerm;
  private isEditable: boolean | string;
  private isRegistrationOpen: boolean;
  private courseLocked: boolean;
  private hasPlannedCourses: boolean;
  private showTermButton: boolean;
  private emphasizeDropAreaBound: () => void;
  private deEmphasizeDropAreaBound: () => void;
  constructor(
    private saveCourseToTermCommand: ICommand,
    private removeCourseFromTermCommand: ICommand,
    private removeCourseGroupFromTermCommand: ICommand,
    private removeCourseFromTermAndAddCourseCommand: ICommand,
    private removeCourseGroupFromTermAndAddCourseGroupCommand: ICommand,
    private saveCourseGroupToTermCommand: ICommand,
    private ngAPPlannedCourseGroupQuery: IQuery,
    private ngAPPlannedCourseQuery: IQuery,
    private ngAPProgramSlotQuery: IQuery,
    private ngStudentValueModel: StudentValueModel,
    private deleteTermCommand: ICommand,
    private $timeout: ng.ITimeoutService,
    private $rootScope: ng.IRootScopeService,
    private $scope: ng.IScope,
    private ngAPComponentStateModel: APComponentStateModel,
    private $state: any,
    private phxAxTitleAnnouncerDelegate: any,
    private appConfigModel: any,
    private FEATURE_SCHEDULER_NK: any,
    private $element: ng.IAugmentedJQuery,
    private ngComponentCommunicatorService: CommunicatorService,
    private ngLargeCourseGroupSearchResultsQuery: LargeCourseGroupSearchResultsQuery
  ) {
    this.flags = {
      isSaving: false,
      showBox: true
    };
  }
  $onChanges(changes: any) {
    this.initialize();
  }
  $onInit() {
    this.emphasizeDropAreaBound = this.emphasizeDropArea.bind(this);
    this.deEmphasizeDropAreaBound = this.deEmphasizeDropArea.bind(this);
    this.ngComponentCommunicatorService.subscribe(EMPHASIZE_DROP_AREA, this.emphasizeDropAreaBound);
    this.ngComponentCommunicatorService.subscribe(DEEMPHASIZE_DROP_AREA, this.deEmphasizeDropAreaBound);
    this.initialize();
  }

  toggleDragState() {
    this.$timeout(() => angular.element('body').toggleClass('dnd-course-delete'), 0);
  }

  dragStarted(slot: APGenericSlot) {
    this.draggingGenericSlot = slot;
    this.ngComponentCommunicatorService.publish(EMPHASIZE_DROP_AREA);
    this.toggleDragState();
  }

  dragCompleted() {
    this.draggingGenericSlot = undefined;
    this.ngComponentCommunicatorService.publish(DEEMPHASIZE_DROP_AREA);
    this.toggleDragState();
  }

  emphasizeDropArea() {
    if (!_4.isUndefined(this.draggingGenericSlot) || this.isPast) {
      return;
    }
    this.isDropAreaActive = true;
  }

  deEmphasizeDropArea() {
    this.isDropAreaActive = false;
  }

  initialize() {
    this.isRegistrationOpen =
      !this.isPast &&
      (APTermServant.isPriorityRegistrationOpen(this.term) || APTermServant.isRegistrationOpen(this.term));

    this.$rootScope.$on('my.planner.show.saving.message', (event: any, termId: number) => {
      if (this.term.id === termId) {
        this.flags.isSaving = true;
        this.$timeout(() => {
          this.flags.isSaving = false;
        }, 2000);
      }
    });
    this.hasPlannedCourses = this.isPast || this.term._genericSlots.length > 0;
    this.showTermButton =
      this.appConfigModel.isFeatureEnabled(this.FEATURE_SCHEDULER_NK) &&
      RoleTypeStrategy.evaluate(this.$state) === 'student';
    this.isEditable = _4.isBoolean(this.isEditable) ? this.isEditable : this.isEditable === 'true';
  }

  insertCallback(event: any, index: number, genericSlot: APGenericSlot, external: any, courseType: string) {
    let duplicatePlannedCourse = {};
    let alreadyPlanned = {};
    let plannedElement;

    if (!APGenericSlotServant.isNCRSlot(genericSlot) && !_4.isEmpty(genericSlot.plannedCourse)) {
      const plannedCourseId = _4.get(genericSlot, 'plannedCourse.id');
      duplicatePlannedCourse = _4.find(this.term._plannedCourses, { id: plannedCourseId });
      alreadyPlanned = _4.find(this.ngAPPlannedCourseQuery.result, (plannedCourse) => plannedCourseId);
      plannedElement = genericSlot.plannedCourse;
    } else if (!APGenericSlotServant.isCourseSlot(genericSlot) && !_4.isEmpty(genericSlot.plannedCourseGroup)) {
      // Case planned course group (placeHolder)
      duplicatePlannedCourse = _4.find(this.term._plannedCourseGroups, {
        id: _4.get(genericSlot, 'plannedCourseGroup.id')
      });
      alreadyPlanned = _4.find(this.ngAPPlannedCourseGroupQuery.result, (plannedCourse) =>
        _4.get(genericSlot, 'plannedCourseGroup.id')
      );
      plannedElement = _4.get(genericSlot, 'plannedCourseGroup');
    }

    if (!_4.isEmpty(alreadyPlanned) && _4.isEmpty(duplicatePlannedCourse)) {
      this.removeFromPlan(genericSlot, plannedElement, true);
    } else if (_4.isEmpty(alreadyPlanned)) {
      this.addToPlan(genericSlot);
    }
  }
  $onDestroy() {
    this.ngComponentCommunicatorService.release(EMPHASIZE_DROP_AREA, this.emphasizeDropAreaBound);
    this.ngComponentCommunicatorService.release(DEEMPHASIZE_DROP_AREA, this.deEmphasizeDropAreaBound);
  }

  addToPlan(genericSlot: APGenericSlot) {
    const plannedCourse = genericSlot.type !== 'NCR' && genericSlot.plannedCourse;
    const slot = genericSlot.programSlot;

    if (_4.isEmpty(plannedCourse)) {
      if (!APGenericSlotServant.isCourseSlot(genericSlot)) {
        this.saveCourseGroupToTermCommand({
          course_group: genericSlot.programSlot.course_group,
          term: this.term.id,
          program_slot: genericSlot.programSlot.id
        }).then((plndCourse: any) => {
          this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
          this.phxAxTitleAnnouncerDelegate.announceChange(
            `place holder ${genericSlot.title} added to ${this.term.name}`
          );
          this.ngAPComponentStateModel.courseGroupClose(slot.id);
        });
      } else if (APGenericSlotServant.isCourseSlot(genericSlot)) {
        this.saveCourseToTermCommand(
          genericSlot.course.id,
          this.term.id,
          slot,
          !!genericSlot.programSlot.is_devreq
        ).then((plndCourse: any) => {
          this.ngAPComponentStateModel.courseGroupClose(slot.id);
          this.phxAxTitleAnnouncerDelegate.announceChange(`course ${genericSlot.title} added to ${this.term.name}`);
        });
      }
    }
    // When a course is planned from large course group, close the large course group view.
    if (_4.includes(this.$state.current.name, 'coursegroup')) {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
    }
  }
  removeFromPlan(genericSlot: APGenericSlot, movedPlannedCourse: any, isTermMove: boolean) {
    if (!APGenericSlotServant.isCourseSlot(genericSlot) && !_4.isEmpty(genericSlot.plannedCourseGroup)) {
      this.removeCourseGroupFromTermAndAddCourseGroupCommand(
        genericSlot.programSlot._course_group,
        genericSlot.programSlot._course_group,
        this.term.id
      ).then(() => {
        this.phxAxTitleAnnouncerDelegate.announceChange(`place holder ${genericSlot.title} moved to ${this.term.name}`);
      });
    } else if (!APGenericSlotServant.isNCRSlot(genericSlot) && genericSlot.plannedCourse) {
      const plndCourse = genericSlot.plannedCourse;
      this.removeCourseFromTermAndAddCourseCommand(
        {
          course: genericSlot.plannedCourse.course,
          id: genericSlot.plannedCourse.id
        },
        {
          id: genericSlot.plannedCourse.course
        },
        genericSlot.programSlot,
        genericSlot.termId,
        this.term.id
      ).then(() => {
        this.phxAxTitleAnnouncerDelegate.announceChange(
          `course ${plndCourse._course.title} moved to ${this.term.name}`
        );
      });
    }
  }

  hasRegisteredCourses() {
    return !!_4.find(this.term._plannedCourses, (course: ICourse) => !!course.status);
  }

  deleteTerm() {
    this.flags.showBox = false;
    this.deleteTermCommand(this.term);
  }
}

class TermBoxComponent implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: string;
  constructor() {
    this.bindings = {
      term: '<',
      isPast: '<?',
      isEditable: '<?'
    };
    this.controller = TermBox;
    this.templateUrl = 'capability-ng-academic-planner/src/plan/components/term_box/term_box.html';
  }
}
angular.module('capability-ng-academic-planner').component('eabMyPlannerTermBox', new TermBoxComponent());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/components/term_box/term_box.ts